// src/theme/atomic/redOrange.ts
var redOrange = {
  10: "#290F00",
  20: "#592100",
  30: "#913500",
  40: "#C94A00",
  50: "#FF5E00",
  60: "#FF7B2E",
  70: "#FF9B61",
  80: "#FFBD96",
  90: "#FED9C4",
  95: "#FEEEE5",
  99: "#FFFAF7"
};
var redOrange_default = redOrange;

export { redOrange_default as default };
